import { DEVICE_TYPE } from "@/Modules/App/Models/Domain/AppState";

const agentDetector = (): DEVICE_TYPE => {
  // (A) BREAK USER AGENT DOWN
  const isMobile = navigator.userAgent.match(/mobile/i),
    isTablet = navigator.userAgent.match(/tablet/i),
    isAndroid = navigator.userAgent.match(/android/i),
    isiPhone = navigator.userAgent.match(/iphone/i),
    isiPad = navigator.userAgent.match(/ipad/i);

  if (isTablet || isiPad || isiPhone || isAndroid || isMobile) return DEVICE_TYPE.MOBILE;

  return DEVICE_TYPE.DESKTOP;
};

export const isChrome = (): boolean => {
  const userAgent = window.navigator.userAgent;

  return new RegExp("chrome", "gi").test(userAgent);
};

export const isIphone = (): boolean => {
  const userAgent = window.navigator.userAgent;

  return new RegExp("iphone", "gi").test(userAgent);
};

export const isSafariMobile = (): boolean => {
  return agentDetector() === DEVICE_TYPE.MOBILE && isSafari() && isIphone();
};

export const isSafari = (): boolean => {
  const userAgent = window.navigator.userAgent;

  return !isChrome() && new RegExp("safari", "gi").test(userAgent);
};

export default agentDetector;
